import { Component } from '@angular/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.html',
})

export class RegisterComponent  {


}
